import React from 'react';
import { BrowserRouter, Navigate, Routes, Route } from 'react-router';
import { App } from '@exiftrator/shared';
import type { LicenseAdapter } from '@exiftrator/shared/types';
import { ThemeProvider } from '@exiftrator/shared/contexts';
import OpticLanding from './pages/landing/OpticLanding';
import DemoPage from './pages/DemoPage';
import FixScannedPhotoDatesPage from './pages/FixScannedPhotoDatesPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';

// Passthrough router — since BrowserRouter is already at the top level,
// App doesn't need its own router. This satisfies the router prop type.
function PassthroughRouter({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}

export function WebRouter({
  appLicenseAdapter,
  demoLicenseAdapter,
}: {
  appLicenseAdapter: LicenseAdapter;
  demoLicenseAdapter: LicenseAdapter;
}) {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={
          <ThemeProvider>
            <OpticLanding />
          </ThemeProvider>
        } />
        <Route path="/fix-scanned-photo-dates" element={
          <ThemeProvider>
            <FixScannedPhotoDatesPage />
          </ThemeProvider>
        } />
        <Route path="/privacy" element={
          <ThemeProvider>
            <PrivacyPolicyPage />
          </ThemeProvider>
        } />
        <Route path="/demo/*" element={
          <ThemeProvider>
            <DemoPage licenseAdapter={demoLicenseAdapter} />
          </ThemeProvider>
        } />
        <Route path="/app/*" element={
          <App router={PassthroughRouter} basePath="/app" licenseAdapter={appLicenseAdapter} />
        } />
      </Routes>
    </BrowserRouter>
  );
}
